// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__VXbPS","list":"BalanceDue_list__3snaH","listRow":"BalanceDue_listRow__3bUc3","total":"BalanceDue_total__3AGrp"};